import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { lightPalette, darkPalette } from './palette';
import { typography } from './typography';
import { components } from './components';
import { shape } from './shape';
import { getBrand } from './brand';

export const getTheme = (mode = 'light') => {
  const palette = mode === 'dark' ? darkPalette : lightPalette;

  let base = createTheme({
    palette,
    typography,
    shape,
    components: components(palette),
    spacing: 8,
  });

  // Attach custom brand tokens (non-MUI) for convenient access via useTheme()
  base.brand = getBrand(mode);

  base = responsiveFontSizes(base);
  return base;
};

export default getTheme;


